import React from 'react'
import { Box, HStack, Link, SimpleGrid, Text } from '@chakra-ui/react'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { PhoneIcon, EmailIcon } from '@chakra-ui/icons';
const Contact = () => {
  return (
    <Box height='auto' marginTop='10' id="contact" >
      <HStack width={'100%'} color="white" alignItems={'center'} justifyContent={'center'} fontWeight={'500'} height={['50px', '60px', '70px']} bg={'gray.800'}>
        <Text fontSize={'xl'}>Contact</Text>
      </HStack>
      <Box marginTop='6' width={'90%'} margin='auto' >
        <Text fontSize={[16, 18, 26]} textAlign='center' color={'white'}><b> <u>Contact me on</u> </b></Text>
        <SimpleGrid columns={[1,2,2]} width='100%' margin='auto'>
        <Box width={'100%'} margin='auto' padding={['0px','10px','30px']}>
          <Box marginTop={'5'}>
            <Box>
              <PhoneIcon width='30px' height={'30px'} color='white' /><Link to='#' marginLeft='4' color='white' fontSize={'18'}>+91-9482318954</Link>
            </Box>
          </Box>
          <Box marginTop={'5'}>
            <Box>
              <EmailIcon width='30px' height={'30px'} color='white' /><Link href='#' marginLeft='5' color='white' fontSize={'18'}>gprasadbhat948231@gmail.com</Link>
            </Box>
          </Box>
        </Box>
        <Box width={'100%'} margin='auto' padding={['0px','10px','30px']}>
          <Box marginTop={'5'}>
            <Box display={'flex'}>
              <FaGithub size='35px' color='white' /><Link href='https://github.com/gprasadbhat948231' target={'_blank'} marginLeft='4' color='white' fontSize={'18'}>GitHub</Link>
            </Box>
          </Box>
          <Box marginTop={'5'}>
            <Box display={'flex'}>
              <FaLinkedin size='35px' color='white' /><Link href='https://www.linkedin.com/in/g-prasad-bhat-1b1345155/' target={'_blank'} marginLeft='4' color='white' fontSize={'18'}>Linkedin</Link>
            </Box>
          </Box>
        </Box>
        </SimpleGrid>
      </Box>
    </Box>
  )
}

export default Contact